import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineStepProps {
  week: string;
  title: string;
  tasks: string[];
  isActive?: boolean;
}

const TimelineStep = ({ week, title, tasks, isActive = false }: TimelineStepProps) => {
  return (
    <div className={`relative pl-8 pb-8 ${isActive ? 'opacity-100' : 'opacity-70'}`}>
      <div
        className={`absolute left-0 top-0 w-6 h-6 rounded-full flex items-center justify-center ${
          isActive ? 'bg-brand-purple' : 'bg-secondary'
        }`}
      >
        <Icon name="CheckIcon" size={14} variant="solid" className="text-white" />
      </div>
      <div className="absolute left-3 top-6 bottom-0 w-0.5 bg-border"></div>

      <div className="bg-card rounded-lg p-6 shadow-soft">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-semibold text-accent uppercase tracking-wide">{week}</span>
          {isActive && (
            <span className="bg-brand-purple text-white px-2 py-1 rounded text-xs font-semibold">
              Current
            </span>
          )}
        </div>
        <h4 className="text-lg font-headline font-bold text-text-primary mb-3">{title}</h4>
        <ul className="space-y-2">
          {tasks.map((task, index) => (
            <li key={index} className="flex items-start space-x-2 text-sm text-text-secondary">
              <Icon
                name="CheckCircleIcon"
                size={16}
                variant="solid"
                className="text-success mt-0.5 flex-shrink-0"
              />
              <span>{task}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TimelineStep;